<script setup>
  const props = defineProps({
    content: { type: String },
    size: { type: String, default: 'sm' },
    placement: { type: String, default: 'bottom' },
    class: { type: String, default: '' }
  })

  const sizes = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  }
</script>

<template>
  <ClientOnly>
    <div :class="`inline-block ${props.class}`">
      <Popper :placement="placement" hover offsetDistance="4">
        <slot name="default" />
        <template #content>
          <div :class="['whitespace-nowrap rounded bg-zinc-300 px-2 py-1 text-center font-normal !text-tarawera-900 shadow', sizes[props.size]]">
            <template v-if="content">{{ content }}</template>
            <slot v-else name="content" />
          </div>
        </template>
      </Popper>
    </div>

    <template #fallback>
      <div class="inline-block" :title="content">
        <slot name="default" />
      </div>
    </template>
  </ClientOnly>
</template>
